export var ADDRESS_PATTERN = /^[A-Za-z0-9 #.,:'-]*$/;
export var PO_TEXT_RESTRICTION_PATTERN = /^po[a-zA-Z]{1}.*$|^.*[a-zA-Z]{1}po$|^.*[a-zA-Z]{1}po[a-zA-Z]{1}.*$/;
export var CITY_PATTERN = /^[A-Za-z0-9 .\-']*$/;
export var ZIP_PATTERN = /^(\d{5}$|\d{5}-\d{4}$)/;
//# sourceMappingURL=address.js.map